import {inject, injectable} from 'inversify';

import type {BaseDomainFactory} from '../Base/BaseDomain.factory';

import {ModelsRegistry} from '../../system/modelsRegistry/ModelsRegistry';
import {GoalModel} from './Goal.model';

@injectable()
export class GoalFactory
  implements BaseDomainFactory<GoalModel, GoalModel.Props>
{
  constructor(
    @inject(ModelsRegistry)
    private readonly modelsRegistry: ModelsRegistry,
  ) {}

  create(props: GoalModel.Props): GoalModel {
    return this.modelsRegistry.put(new GoalModel(props));
  }
}
